<template>
  <div
    :class="`BgFilterBubble  ${active && 'BgFilterBubble--active'} ${
      variant && `BgFilterBubble--${variant}`
    }`"
  >
    {{ text }}
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  name: "BgFilterBubble",
  props: {
    text: String,
    active: Boolean,
    variant: String,
  },
};
</script>
